var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4283 0H3.28544C1.55686 0 0.158292 1.41429 0.158292 3.14286L0.142578 22C0.142578 23.7286 1.55686 25.1429 3.28544 25.1429H28.4283C30.1569 25.1429 31.5712 23.7286 31.5712 22V3.14286C31.5712 1.41429 30.1569 0 28.4283 0ZM27.7997 6.67857L16.6897 13.6243C16.1869 13.9386 15.5269 13.9386 15.024 13.6243L3.91401 6.67857C3.75644 6.59012 3.61845 6.47061 3.5084 6.32728C3.39836 6.18396 3.31853 6.01979 3.27377 5.84472C3.229 5.66966 3.22023 5.48733 3.24797 5.30877C3.27571 5.13021 3.33939 4.95913 3.43516 4.8059C3.53094 4.65267 3.6568 4.52046 3.80515 4.41728C3.95349 4.3141 4.12123 4.24209 4.29821 4.20561C4.4752 4.16913 4.65774 4.16895 4.83479 4.20506C5.01185 4.24117 5.17974 4.31284 5.32829 4.41571L15.8569 11L26.3854 4.41571C26.534 4.31284 26.7019 4.24117 26.8789 4.20506C27.056 4.16895 27.2385 4.16913 27.4155 4.20561C27.5925 4.24209 27.7602 4.3141 27.9086 4.41728C28.0569 4.52046 28.1828 4.65267 28.2786 4.8059C28.3743 4.95913 28.438 5.13021 28.4658 5.30877C28.4935 5.48733 28.4847 5.66966 28.44 5.84472C28.3952 6.01979 28.3154 6.18396 28.2053 6.32728C28.0953 6.47061 27.9573 6.59012 27.7997 6.67857Z",
    fill: "#C31A7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageI);
export default __webpack_public_path__ + "static/media/messageI.41aeae506a48890641a2b775d7621f31.svg";
export { ForwardRef as ReactComponent };